import { createSelector } from 'reselect'

const selectTransactions = state => state.transactions

export const selectAllTransactions = createSelector([selectTransactions], transactions => transactions)

export const selectRecentTransactions = createSelector([selectTransactions], transactions => transactions.recentTransactions)

export const selectFilteredTransactions = createSelector([selectTransactions], transactions => transactions.filteredTransactions)

export const selectLoader = createSelector([selectTransactions], transactions => transactions.loader)

export const selectSuccess = createSelector([selectTransactions], transactions => transactions.success)

export const selectSuccessMsg = createSelector([selectTransactions], transactions => transactions.successMsg)

export const selectAlertTransaction = createSelector([selectTransactions], transactions => transactions.alertTransaction)

export const selectLoadingAlertTransactions = createSelector([selectTransactions], transactions => transactions.loadingAlert)

export const selectPayTransaction = createSelector([selectTransactions], transactions => transactions.payTransaction)

export const selectPdfDownload = createSelector([selectTransactions], transactions => transactions.pdfDownload)

export const selectPdfStatement = createSelector([selectTransactions], transactions => transactions.pdfStatement)

export const selectTextStatement = createSelector([selectTransactions], transactions => transactions.textStatement)

export const selectXmlStatement = createSelector([selectTransactions], transactions => transactions.xmlStatement)

export const selectCsvStatement = createSelector([selectTransactions], transactions => transactions.csvStatement)

export const selectFiles = createSelector([selectTransactions], transactions => transactions.files)

export const selectCounts = createSelector([selectTransactions], transactions => transactions.counts)

export const selectStatuses = createSelector([selectTransactions], transactions => transactions.statuses)
